import type { ReactNode } from "react";
import { BarChart3, Building2, CalendarCheck2, ChartNoAxesCombined, Landmark, LayoutDashboard, ListChecks, ReceiptText, Scale, Settings, UsersRound, WalletCards } from "lucide-react";

export const financialSections = [
  { id: "financeiro/visao-geral", label: "Visão geral", icon: LayoutDashboard },
  { id: "financeiro/movimentacoes", label: "Movimentações", icon: WalletCards },
  { id: "financeiro/conciliacao", label: "Conciliação bancária", icon: ListChecks },
  { id: "financeiro/contas-pagar", label: "Contas a pagar", icon: ReceiptText },
  { id: "financeiro/contas-receber", label: "Contas a receber", icon: BarChart3 },
  { id: "financeiro/contas", label: "Contas financeiras", icon: Landmark },
  { id: "financeiro/resultado-contrato", label: "Resultado por contrato", icon: ChartNoAxesCombined },
  { id: "financeiro/dre-gerencial", label: "DRE Gerencial", icon: BarChart3 },
  { id: "financeiro/posicao-patrimonial", label: "Posição patrimonial", icon: Scale },
  { id: "financeiro/fechamento-mensal", label: "Fechamento mensal", icon: CalendarCheck2 },
  { id: "financeiro/socios", label: "Sócios e patrimônio", icon: UsersRound },
  { id: "financeiro/relatorios", label: "Relatórios", icon: Building2 },
  { id: "financeiro/configuracoes", label: "Configurações", icon: Settings }
];

export function FinancialNavigation({ route, navigate }: { route: string; navigate: (route: string) => void }) {
  return <nav className="financial-section-nav" aria-label="Núcleo financeiro">
    {financialSections.map((item) => <button
      key={item.id}
      className={route === item.id || route.startsWith(`${item.id}/`) ? "active" : ""}
      onClick={() => navigate(item.id)}
    ><item.icon size={16}/><span>{item.label}</span></button>)}
  </nav>;
}

export function FinancialShell({ route, navigate, children }: { route: string; navigate: (route: string) => void; children: ReactNode }) {
  return <div className="financial-shell">
    <FinancialNavigation route={route} navigate={navigate}/>
    {children}
  </div>;
}
